export const getLogoStyles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    height: 60,
  },
  logo: {
    height: 20,
    width: 100,
  },
  logoClickable: {
    cursor: 'pointer',
  },
  logoUnclickable: {
    cursor: 'auto',
  },
  logoContainer: {
    padding: '0px 8px 0px 20px',
    height: 20,
  },
  divider: {
    borderLeftColor: 'white',
    borderLeftWidth: 1,
    borderLeftStyle: 'solid',
    height: 40,
    marginTop: 10,
    marginBottom: 10,
    width: 0,
  },
  item: {
    marginLeft: 0,
    marginRight: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: '#FFFFFF',
    fontSize: '16px',
    lineHeight: '20px',
    fontFamily: 'Segoe UI',
    marginTop: 19,
    marginBottom: 21,
    textAlign: 'center',
    paddingLeft: 0,
    paddingRight: 8,
    fontWeight: 500,
  },
  logoText: {
    /* Targets displays using the Windows’ "High Contrast White" theme: */
    '@media screen and (-ms-high-contrast: black-on-white)': {
      fill: '#737373 !important',
    },
  },
});
